<div kendoTooltip [tooltipTemplate]="template">
  <span title="{{tooltip}}" class="text-secondary">{{text}}</span>
</div>

<ng-template #template let-anchor>
  <div>{{ anchor | tooltip }}</div>
</ng-template>
